import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import makeRequest from 'utils/makeRequest';
import { getSiteDomain } from 'utils/common';
import TimelinePoll from 'routes/liveblog_v2/components/common/TimelinePoll';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Cookie from 'utils/cookies';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class PollWidgetMain extends React.Component {
  constructor() {
    super();
    this.state = {
      items: [],
      isPollAlreadyDone: false,
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { data } = nextProps;
    if (
      Array.isArray(data) &&
      typeof window !== 'undefined' &&
      prevState.isPollAlreadyDone !== nextProps.isPollAlreadyDone
    ) {
      const isPollAlreadyDone = !!Cookie.get(`POLLID${data[0].msid}`);
      return {
        items: data,
        isPollAlreadyDone,
      };
    }
    return null;
  }
  componentDidMount() {
    const { dataUrl } = this.props;
    if (dataUrl) {
      this.loadPollData(dataUrl);
    }
    if (sessionStorage.getItem('previousPage') !== window?.location?.pathname) {
      sessionStorage.removeItem('pollResultID');
      sessionStorage.removeItem('pollResult');
      sessionStorage.removeItem('previousPage');
      sessionStorage.removeItem('selectedOption');
    }
  }

  setData = (data, isPollAlreadyDone) => {
    const finalData = [...data.data.items];
    if (
      finalData[0] &&
      Array.isArray(finalData[0].options) &&
      finalData[0].options.length > 2
    ) {
      finalData[0] = {
        ...finalData[0],
        options: [...finalData[0].options].reverse(),
      };
    }
    this.setState({
      items: finalData,
      isPollAlreadyDone,
    });
  };

  loadFallBackData = () => {
    const fallBackDataUrl = `${getSiteDomain()}/poll_wrapper/section-2238809,feedtype-sjson.cms`;
    makeRequest
      .get(fallBackDataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          const pollId = data.data.items[0].id || data.data.items[0].msid;
          const isPollAlreadyDone = !!Cookie.get(`POLLID${pollId}`);

          if (
            !Cookie.get(`POLLID${data.data.items[0].id}`) ||
            (sessionStorage.getItem('previousPage') ===
              window?.location?.pathname &&
              Cookie.get(`POLLID${data.data.items[0].id}`) ===
                sessionStorage.getItem('pollResultID'))
          ) {
            this.setData(data, isPollAlreadyDone);
          } else if (
            this.props.noShowpoll &&
            typeof this.props.noShowpoll === 'function'
          ) {
            this.props.noShowpoll(false);
          }
          // if (
          //   sessionStorage.getItem('previousPage') ===
          //     window?.location?.pathname &&
          //   Cookie.get(`POLLID${data.data.items[0].id}`) ===
          //     sessionStorage.getItem('pollResultID')
          // ) {
          //   this.setData(data, isPollAlreadyDone);
          // }
        }
      });
  };

  loadPollData(dataUrl) {
    if (!dataUrl) {
      return;
    }

    // const { fallback } = this.props;

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          // if (showpoll || !Cookie.get(`POLLID${data.data.items[0].id}`)) {
          //   this.setState({
          //     items: data.data.items,
          //   });
          // } else if (typeof fallback === 'function') {
          //   fallback();
          // }
          const pollId = data.data.items[0].id || data.data.items[0].msid;
          const isPollAlreadyDone = !!Cookie.get(`POLLID${pollId}`);

          if (!Cookie.get(`POLLID${data.data.items[0].id}`)) {
            this.setData(data, isPollAlreadyDone);
          } else if (
            sessionStorage.getItem('previousPage') ===
              window?.location?.pathname &&
            Cookie.get(`POLLID${data.data.items[0].id}`) ===
              sessionStorage.getItem('pollResultID')
          ) {
            this.setData(data, isPollAlreadyDone);
          } else {
            this.loadFallBackData();
          }
        } else {
          this.props.noShowpoll(false);
        }
      });
  }

  addPollToStorage = () => {
    const { isElectionPoll, ga4Type, userData } = this.props;
    const { isLoggedIn } = userData;

    const pollId = this.state.items[0].id || this.state.items[0].msid;
    const pollQuestion = this.state.items[0].hl;
    if (isLoggedIn) {
      Cookie.set(`POLLID${pollId}`, pollId, 1, '/');
    }

    const gaData = {
      gaAction: 'Poll_Submit',
      gaLabel: pollId,
    };
    if (isElectionPoll) {
      gaData.gaCategory = 'Elections_Poll';
    }
    sendGaThroughProps({ data: gaData });
    if (typeof ga4Type !== 'undefined' && ga4Type !== '' && isLoggedIn) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        category: 'poll_submit',
        msid: pollId,
        page_title: pollQuestion,
        login_status: isLoggedIn,
      });
    }
  };

  render() {
    const { data, isExternalClass, userData, ...rest } = this.props;
    const { isLoggedIn, ...restWithoutIsLogin } = rest;
    const { items, isPollAlreadyDone } = this.state;
    const itemsList = Array.isArray(data) ? data : items || [];
    if (!itemsList || itemsList.length === 0) {
      return null;
    }
    return (
      <div style={{ marginTop: '8px' }} className={isExternalClass}>
        <TimelinePoll
          data={{ ...itemsList[0] }}
          isLoggedIn={this.props.userData.isLoggedIn || this.props.isLoggedIn}
          pollSubmitCallback={this.addPollToStorage}
          pollDone={isPollAlreadyDone}
          {...restWithoutIsLogin}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.isMobile,
  userData: _get(state, 'login.userData', {}),
});

PollWidgetMain.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  isLoggedIn: PropTypes.bool,
  dataUrl: PropTypes.string,
  fallback: PropTypes.func,
  isElectionPoll: PropTypes.bool,
  isExternalClass: PropTypes.bool,
  isMobile: PropTypes.bool,
  userData: PropTypes.shape({}),
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
};

PollWidgetMain.defaultProps = {
  data: undefined,
  isLoggedIn: false,
  dataUrl: '',
  fallback: () => {},
  isElectionPoll: false,
  isExternalClass: false,
  isMobile: false,
  userData: {},
  ga4Type: '',
  ga4Category: '',
};

export default connect(mapStateToProps)(PollWidgetMain);
